var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 16.8791C19.4546 18.0744 19.1909 18.6137 18.4909 19.6653C17.5092 21.1393 16.1274 22.9818 14.4092 22.9998C12.882 23.0177 12.4911 22.0201 10.4275 22.0291C8.36394 22.0381 7.92759 23.0177 6.40036 22.9998C4.68222 22.9818 3.37316 21.319 2.39137 19.845C-0.354014 15.7107 -0.644915 10.8662 1.05504 8.28674C2.25501 6.45323 4.15496 5.38369 5.94582 5.38369C7.76396 5.38369 8.90029 6.37234 10.4093 6.37234C11.8638 6.37234 12.7547 5.38369 14.8547 5.38369C16.4455 5.38369 18.1273 6.23753 19.3273 7.72051C15.391 9.85062 16.0274 15.3961 20 16.8791ZM13.2547 3.73892C14.0183 2.76824 14.6001 1.4021 14.3911 0C13.1456 0.0808901 11.682 0.871816 10.8366 1.89642C10.0639 2.82217 9.42755 4.1973 9.673 5.53648C11.0275 5.58142 12.4366 4.77252 13.2547 3.73892Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.b1df285550c2284a3682990cf10e212f.svg";
export { ForwardRef as ReactComponent };